import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "min-h-0 flex-1 overflow-y-auto px-6 py-5"
};
const _hoisted_4 = {
  class: "grid grid-cols-1 gap-4 md:grid-cols-2"
};
const _hoisted_5 = {
  class: "block md:col-span-2"
};
const _hoisted_6 = {
  class: "block"
};
const _hoisted_7 = {
  class: "block"
};
const _hoisted_8 = {
  class: "block"
};
const _hoisted_9 = {
  class: "block"
};
const _hoisted_10 = {
  class: "block"
};
const _hoisted_11 = {
  class: "grid grid-cols-1 gap-4 md:col-span-2 md:grid-cols-4"
};
const _hoisted_12 = {
  class: "block"
};
const _hoisted_13 = {
  class: "block"
};
const _hoisted_14 = {
  class: "block"
};
const _hoisted_15 = {
  class: "block"
};
const _hoisted_16 = {
  class: "md:col-span-2"
};
const _hoisted_17 = {
  class: "block md:col-span-2"
};
const _hoisted_18 = {
  key: 0,
  class: "mt-5 rounded-lg border border-slate-200 bg-slate-50 p-4"
};
const _hoisted_19 = {
  class: "inline-flex items-center gap-2 text-sm font-medium text-slate-700"
};
const _hoisted_20 = {
  key: 0,
  class: "mt-4 grid grid-cols-1 gap-4 md:grid-cols-3"
};
const _hoisted_21 = {
  class: "block"
};
const _hoisted_22 = {
  key: 0,
  class: "mt-1 text-xs text-amber-600"
};
const _hoisted_23 = {
  class: "block"
};
const _hoisted_24 = {
  class: "block"
};
const _hoisted_25 = {
  class: "md:col-span-3"
};
const _hoisted_26 = {
  class: "md:col-span-3"
};
const _hoisted_27 = {
  class: "md:col-span-3"
};
const _hoisted_28 = {
  class: "flex justify-end gap-3 border-t border-slate-200 px-6 py-4"
};
const _hoisted_29 = ["disabled"];
const _hoisted_30 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import UserSelector from '@/components/UserSelector/index.vue';
import AppModal from '@/components/AppModal.vue';
import { buildChinaAreaOptions, closeChinaAreaCascaderAfterDistrict, codeTextMap } from '@/utils/chinaAreaOptions.mjs';
import { formatInvoiceAmount, normalizeAmountInput, parsePercentInput } from '../utils';
import { defaultProductQuotas, normalizeProductQuotas, quotaTotalMatched, validateProductQuotaList } from '../productQuota';
import { downstreamDraftSummary } from '../downstreamRules.mjs';
import InvoiceProductQuotaEditor from './InvoiceProductQuotaEditor.vue';
import InvoiceCustomerTagSelect from './InvoiceCustomerTagSelect.vue';
import InvoiceCustomerInvoiceRulePanel from './InvoiceCustomerInvoiceRulePanel.vue';
import InvoiceDownstreamAllocationDialog from './InvoiceDownstreamAllocationDialog.vue';
import InvoiceDownstreamTagPreferenceDialog from './InvoiceDownstreamTagPreferenceDialog.vue';
const DRAFT_PLAN_CUSTOMER_ID = '__new_customer__';
export default {
  __name: 'InvoiceCustomerMasterModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create'
    },
    customer: {
      type: Object,
      default: null
    },
    availableTags: {
      type: Array,
      default: () => []
    },
    selectedTagIds: {
      type: Array,
      default: () => []
    },
    tagsLoading: {
      type: Boolean,
      default: false
    },
    regions: {
      type: Array,
      default: () => []
    },
    customers: {
      type: Array,
      default: () => []
    },
    downstreamAllocations: {
      type: Array,
      default: () => []
    },
    downstreamTagPreferences: {
      type: Array,
      default: () => []
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      companyName: '',
      registeredRegion: '',
      registeredRegionCodes: '',
      financeUserId: null,
      financeUserName: '',
      channelSource: '',
      personalTaxDeclarationCount: null,
      hasProperty: null,
      lastYearActualBusinessScaleWan: null,
      sealManaged: null,
      licenseManaged: null,
      actuallyOperating: null,
      tagIds: [],
      remark: '',
      joinMonth: false,
      targetOutputAmount: null,
      targetProfitRatePercent: '',
      regionBucketId: null,
      inputProductQuotas: defaultProductQuotas(0),
      outputProductQuotas: defaultProductQuotas(0)
    });
    const areaCodes = ref([]);
    const areaCascaderRef = ref(null);
    const amountWarning = ref('');
    const draftDownstreamAllocations = ref([]);
    const draftDownstreamTagPreferences = ref([]);
    const downstreamAllocationDialog = reactive({
      visible: false
    });
    const downstreamTagPreferenceDialog = reactive({
      visible: false
    });
    const isEditMode = computed(() => props.mode === 'edit');
    const isSubmitting = computed(() => props.submitting);
    const modalTitle = computed(() => isEditMode.value ? '编辑客户主档' : '新增客户主档');
    const normalizedTargetAmount = computed(() => normalizeAmountInput(form.targetOutputAmount) || 0);
    const regionTree = computed(() => buildChinaAreaOptions());
    const combinedDraftDownstreamAllocations = computed(() => [...(props.downstreamAllocations || []), ...draftDownstreamAllocations.value]);
    const invoiceRuleCustomer = computed(() => ({
      id: DRAFT_PLAN_CUSTOMER_ID,
      planCustomerId: DRAFT_PLAN_CUSTOMER_ID,
      customerId: null,
      companyName: form.companyName,
      companyNameSnapshot: form.companyName,
      registeredRegion: form.registeredRegion,
      registeredRegionSnapshot: form.registeredRegion,
      regionBucketId: form.regionBucketId,
      targetOutputAmount: normalizedTargetAmount.value,
      targetProfitRate: parsePercentInput(form.targetProfitRatePercent)
    }));
    function resetForm() {
      const customer = props.customer || {};
      Object.assign(form, {
        companyName: customer.companyName || '',
        registeredRegion: customer.registeredRegion || '',
        registeredRegionCodes: customer.registeredRegionCodes || '',
        financeUserId: customer.financeUserId || null,
        financeUserName: customer.financeUserName || '',
        channelSource: customer.channelSource || '',
        personalTaxDeclarationCount: numberOrNull(customer.personalTaxDeclarationCount),
        hasProperty: booleanOrNull(customer.hasProperty),
        lastYearActualBusinessScaleWan: numberOrNull(customer.lastYearActualBusinessScaleWan),
        sealManaged: booleanOrNull(customer.sealManaged),
        licenseManaged: booleanOrNull(customer.licenseManaged),
        actuallyOperating: booleanOrNull(customer.actuallyOperating),
        tagIds: normalizeTagIds(props.selectedTagIds),
        remark: customer.remark || '',
        joinMonth: false,
        targetOutputAmount: null,
        targetProfitRatePercent: '',
        regionBucketId: null,
        inputProductQuotas: defaultProductQuotas(0),
        outputProductQuotas: defaultProductQuotas(0)
      });
      areaCodes.value = parseRegionCodes(form.registeredRegionCodes);
      amountWarning.value = '';
      draftDownstreamAllocations.value = [];
      draftDownstreamTagPreferences.value = [];
      downstreamAllocationDialog.visible = false;
      downstreamTagPreferenceDialog.visible = false;
    }
    function close() {
      emit('update:modelValue', false);
    }
    function numberOrNull(value) {
      if (value === null || value === undefined || value === '') return null;
      const number = Number(value);
      return Number.isFinite(number) ? number : null;
    }
    function booleanOrNull(value) {
      if (value === true || value === 'true' || value === 1 || value === '1') return true;
      if (value === false || value === 'false' || value === 0 || value === '0') return false;
      return null;
    }
    function parseRegionCodes(value) {
      if (!value) return [];
      return String(value).split(',').map(item => item.trim()).filter(Boolean);
    }
    function handleAreaChange(value) {
      const codes = Array.isArray(value) ? value : [];
      areaCodes.value = codes;
      form.registeredRegionCodes = codes.join(',');
      form.registeredRegion = codes.map(code => codeTextMap[code]).filter(Boolean).join('');
      closeChinaAreaCascaderAfterDistrict(areaCascaderRef.value, value);
    }
    function handleFinanceUserConfirm(users) {
      const user = Array.isArray(users) ? users[0] : users;
      form.financeUserId = user?.id || null;
      form.financeUserName = user?.name || user?.displayName || user?.username || '';
    }
    function handleFinanceUserChange(value) {
      form.financeUserId = value || null;
      if (!value) {
        form.financeUserName = '';
      }
    }
    function selectRegion(value) {
      const region = props.regions.find(item => String(item.id) === String(value));
      form.regionBucketId = region ? region.id : null;
    }
    function openDraftDownstreamAllocation() {
      if (!form.joinMonth) return;
      downstreamAllocationDialog.visible = true;
    }
    function openDraftDownstreamTagPreference() {
      if (!form.joinMonth) return;
      downstreamTagPreferenceDialog.visible = true;
    }
    function validateMaster() {
      if (!form.companyName.trim()) {
        ElMessage.warning('请填写公司名称');
        return false;
      }
      if (!form.registeredRegion.trim()) {
        ElMessage.warning('请选择注册地');
        return false;
      }
      if (form.personalTaxDeclarationCount !== null && Number(form.personalTaxDeclarationCount) < 0) {
        ElMessage.warning('个税申报人数不能为负数');
        return false;
      }
      if (form.lastYearActualBusinessScaleWan !== null && Number(form.lastYearActualBusinessScaleWan) < 0) {
        ElMessage.warning('上年实际业务规模不能为负数');
        return false;
      }
      return true;
    }
    function validateMonth() {
      if (!form.joinMonth) return true;
      const normalizedAmount = normalizeAmountInput(form.targetOutputAmount);
      const inputAmount = Number(String(form.targetOutputAmount ?? '').trim());
      if (!Number.isFinite(inputAmount) || normalizedAmount === null || normalizedAmount <= 0) {
        ElMessage.warning('请填写有效的本月开票额度');
        return false;
      }
      if (inputAmount !== normalizedAmount) {
        const warning = '本月开票额度将按 100 元取整为 ' + formatInvoiceAmount(normalizedAmount);
        if (amountWarning.value !== warning) {
          amountWarning.value = warning;
          form.targetOutputAmount = normalizedAmount;
          ElMessage.warning(warning);
          return false;
        }
      }
      const targetProfitRate = parsePercentInput(form.targetProfitRatePercent);
      if (!Number.isFinite(targetProfitRate) || targetProfitRate < 0) {
        ElMessage.warning('请填写有效的本月利润率');
        return false;
      }
      if (!validateProductQuotas(form.inputProductQuotas, '进项品名组结构', normalizedAmount)) return false;
      if (!validateProductQuotas(form.outputProductQuotas, '销项品名组结构', normalizedAmount)) return false;
      if (!validateDraftDownstreamAllocations(normalizedAmount)) return false;
      return true;
    }
    function validateProductQuotas(value, label, targetAmount) {
      const errors = validateProductQuotaList(value, targetAmount);
      if (errors.length === 0 && quotaTotalMatched(value, targetAmount)) return true;
      ElMessage.warning(errors[0] || label);
      return false;
    }
    function nullableNumber(value) {
      const number = numberOrNull(value);
      return number === null ? null : number;
    }
    function validateDraftDownstreamAllocations(targetAmount) {
      const summary = downstreamDraftSummary(draftDownstreamAllocations.value, {
        targetOutputAmount: targetAmount
      });
      if (!summary.overAllocated) return true;
      ElMessage.warning('指定下游金额不能超过本月开票额度');
      return false;
    }
    function targetCustomerName(planCustomerId) {
      const target = (props.customers || []).find(item => String(item.id ?? item.planCustomerId) === String(planCustomerId));
      return target?.companyNameSnapshot || target?.companyName || target?.customerName || target?.name || '';
    }
    function tagName(tagId) {
      const tag = (props.availableTags || []).find(item => String(item.id) === String(tagId));
      return tag?.tagName || tag?.name || '';
    }
    function saveDraftDownstreamAllocations(payload) {
      draftDownstreamAllocations.value = (payload?.allocations || []).map((item, index) => ({
        ...item,
        fromPlanCustomerId: DRAFT_PLAN_CUSTOMER_ID,
        toCompanyName: targetCustomerName(item.toPlanCustomerId),
        displayOrder: Number(item.displayOrder || index + 1)
      }));
      downstreamAllocationDialog.visible = false;
    }
    function saveDraftDownstreamTagPreferences(payload) {
      draftDownstreamTagPreferences.value = (payload?.preferences || []).map((item, index) => ({
        ...item,
        fromPlanCustomerId: DRAFT_PLAN_CUSTOMER_ID,
        tagName: tagName(item.tagId),
        priority: Number(item.priority || index + 1)
      }));
      downstreamTagPreferenceDialog.visible = false;
    }
    function submitDownstreamAllocations() {
      return draftDownstreamAllocations.value.map((item, index) => ({
        toPlanCustomerId: item.toPlanCustomerId,
        amount: Number(item.amount),
        enabled: item.enabled !== false,
        displayOrder: Number(item.displayOrder || index + 1),
        remark: item.remark || null
      }));
    }
    function submitDownstreamTagPreferences() {
      return draftDownstreamTagPreferences.value.map((item, index) => ({
        tagId: item.tagId,
        priority: Number(item.priority || index + 1),
        enabled: item.enabled !== false
      }));
    }
    function buildPayload() {
      const customer = {
        companyName: form.companyName.trim(),
        registeredRegion: form.registeredRegion.trim(),
        registeredRegionCodes: form.registeredRegionCodes || null,
        financeUserId: form.financeUserId || null,
        financeUserName: form.financeUserName || null,
        channelSource: form.channelSource?.trim() || null,
        personalTaxDeclarationCount: nullableNumber(form.personalTaxDeclarationCount),
        hasProperty: form.hasProperty,
        lastYearActualBusinessScaleWan: nullableNumber(form.lastYearActualBusinessScaleWan),
        sealManaged: form.sealManaged,
        licenseManaged: form.licenseManaged,
        actuallyOperating: form.actuallyOperating,
        remark: form.remark?.trim() || null
      };
      const targetOutputAmount = form.joinMonth ? normalizeAmountInput(form.targetOutputAmount) : null;
      const month = {
        targetOutputAmount,
        targetProfitRate: form.joinMonth ? parsePercentInput(form.targetProfitRatePercent) : null,
        regionBucketId: form.joinMonth ? form.regionBucketId : null,
        inputProductQuotas: form.joinMonth ? normalizeProductQuotas(form.inputProductQuotas, targetOutputAmount) : null,
        outputProductQuotas: form.joinMonth ? normalizeProductQuotas(form.outputProductQuotas, targetOutputAmount) : null,
        downstreamAllocations: form.joinMonth ? submitDownstreamAllocations() : null,
        downstreamTagPreferences: form.joinMonth ? submitDownstreamTagPreferences() : null
      };
      return {
        customer,
        tagIds: normalizeTagIds(form.tagIds),
        joinMonth: !isEditMode.value && form.joinMonth,
        month
      };
    }
    function normalizeTagIds(value) {
      return Array.isArray(value) ? value.filter(item => item !== null && item !== undefined && item !== '') : [];
    }
    async function submit() {
      if (isSubmitting.value) return;
      if (!validateMaster() || !validateMonth()) return;
      emit('submit', buildPayload());
    }
    watch(() => props.modelValue, value => {
      if (value) resetForm();
    });
    watch(() => props.customer, () => {
      if (props.modelValue) resetForm();
    });
    watch(() => props.selectedTagIds, value => {
      if (props.modelValue) {
        form.tagIds = normalizeTagIds(value);
      }
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "4xl",
        "panel-class": "max-h-[92vh]",
        "z-index": 70,
        scrollable: false,
        onClose: close
      }, {
        default: _withCtx(() => [_createElementVNode("header", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(modalTitle.value), 1), _cache[20] || (_cache[20] = _createElementVNode("p", {
          class: "mt-1 text-sm text-slate-500"
        }, "维护企营增客户主档信息，规划师由系统按创建人自动记录。", -1))]), _createElementVNode("button", {
          type: "button",
          class: "rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
          onClick: close
        }, [...(_cache[21] || (_cache[21] = [_createElementVNode("span", {
          class: "sr-only"
        }, "关闭", -1), _createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("main", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("label", _hoisted_5, [_cache[22] || (_cache[22] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("公司名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.companyName = $event),
          type: "text",
          class: "form-input mt-1 w-full",
          placeholder: "请输入公司名称"
        }, null, 512), [[_vModelText, form.companyName]])]), _createElementVNode("label", _hoisted_6, [_cache[23] || (_cache[23] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("注册地 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_cascader, {
          ref_key: "areaCascaderRef",
          ref: areaCascaderRef,
          modelValue: areaCodes.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => areaCodes.value = $event),
          options: regionTree.value,
          props: {
            checkStrictly: true
          },
          placeholder: "请选择省市区",
          filterable: "",
          clearable: "",
          class: "mt-1 w-full",
          onChange: handleAreaChange
        }, null, 8, ["modelValue", "options"])]), _createElementVNode("label", _hoisted_7, [_cache[24] || (_cache[24] = _createElementVNode("span", {
          class: "form-label"
        }, "财务专员", -1)), _createVNode(UserSelector, {
          modelValue: form.financeUserId,
          "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => form.financeUserId = $event), handleFinanceUserChange],
          class: "mt-1",
          multiple: false,
          placeholder: "请选择财务专员",
          onConfirm: handleFinanceUserConfirm
        }, null, 8, ["modelValue"])]), _createElementVNode("label", _hoisted_8, [_cache[25] || (_cache[25] = _createElementVNode("span", {
          class: "form-label"
        }, "渠道来源", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.channelSource = $event),
          type: "text",
          maxlength: "128",
          class: "form-input mt-1 w-full",
          placeholder: "请输入渠道来源"
        }, null, 512), [[_vModelText, form.channelSource]])]), _createElementVNode("label", _hoisted_9, [_cache[26] || (_cache[26] = _createElementVNode("span", {
          class: "form-label"
        }, "个税申报人数", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.personalTaxDeclarationCount = $event),
          type: "number",
          min: "0",
          step: "1",
          class: "form-input mt-1 w-full",
          placeholder: "请输入人数"
        }, null, 512), [[_vModelText, form.personalTaxDeclarationCount, void 0, {
          number: true
        }]])]), _createElementVNode("label", _hoisted_10, [_cache[27] || (_cache[27] = _createElementVNode("span", {
          class: "form-label"
        }, "上年实际业务规模（万元）", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.lastYearActualBusinessScaleWan = $event),
          type: "number",
          min: "0",
          step: "0.01",
          class: "form-input mt-1 w-full",
          placeholder: "单位：万元"
        }, null, 512), [[_vModelText, form.lastYearActualBusinessScaleWan, void 0, {
          number: true
        }]])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("label", _hoisted_12, [_cache[28] || (_cache[28] = _createElementVNode("span", {
          class: "form-label"
        }, "是否有房产", -1)), _createVNode(_component_el_select, {
          modelValue: form.hasProperty,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.hasProperty = $event),
          class: "form-select mt-1 w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "未知",
            value: null
          }), _createVNode(_component_el_option, {
            label: "是",
            value: true
          }), _createVNode(_component_el_option, {
            label: "否",
            value: false
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("label", _hoisted_13, [_cache[29] || (_cache[29] = _createElementVNode("span", {
          class: "form-label"
        }, "是否三章代管", -1)), _createVNode(_component_el_select, {
          modelValue: form.sealManaged,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.sealManaged = $event),
          class: "form-select mt-1 w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "未知",
            value: null
          }), _createVNode(_component_el_option, {
            label: "是",
            value: true
          }), _createVNode(_component_el_option, {
            label: "否",
            value: false
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("label", _hoisted_14, [_cache[30] || (_cache[30] = _createElementVNode("span", {
          class: "form-label"
        }, "是否营业执照代管", -1)), _createVNode(_component_el_select, {
          modelValue: form.licenseManaged,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.licenseManaged = $event),
          class: "form-select mt-1 w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "未知",
            value: null
          }), _createVNode(_component_el_option, {
            label: "是",
            value: true
          }), _createVNode(_component_el_option, {
            label: "否",
            value: false
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("label", _hoisted_15, [_cache[31] || (_cache[31] = _createElementVNode("span", {
          class: "form-label"
        }, "是否实际经营", -1)), _createVNode(_component_el_select, {
          modelValue: form.actuallyOperating,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.actuallyOperating = $event),
          class: "form-select mt-1 w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "未知",
            value: null
          }), _createVNode(_component_el_option, {
            label: "是",
            value: true
          }), _createVNode(_component_el_option, {
            label: "否",
            value: false
          })]),
          _: 1
        }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_16, [_createVNode(InvoiceCustomerTagSelect, {
          modelValue: form.tagIds,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.tagIds = $event),
          tags: __props.availableTags,
          loading: __props.tagsLoading,
          disabled: isSubmitting.value
        }, null, 8, ["modelValue", "tags", "loading", "disabled"])]), _createElementVNode("label", _hoisted_17, [_cache[32] || (_cache[32] = _createElementVNode("span", {
          class: "form-label"
        }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.remark = $event),
          rows: "3",
          maxlength: "1000",
          class: "form-textarea mt-1 w-full",
          placeholder: "请输入备注"
        }, null, 512), [[_vModelText, form.remark]])])]), !isEditMode.value ? (_openBlock(), _createElementBlock("section", _hoisted_18, [_createElementVNode("label", _hoisted_19, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.joinMonth = $event),
          type: "checkbox",
          class: "h-4 w-4 rounded border-slate-300 text-primary-600"
        }, null, 512), [[_vModelCheckbox, form.joinMonth]]), _cache[33] || (_cache[33] = _createTextVNode(" 同时加入当前月 ", -1))]), form.joinMonth ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("label", _hoisted_21, [_cache[34] || (_cache[34] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("本月开票额度 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.targetOutputAmount = $event),
          type: "number",
          min: "0",
          step: "100",
          class: "form-input mt-1 w-full bg-white",
          placeholder: "请输入额度",
          onInput: _cache[14] || (_cache[14] = $event => amountWarning.value = '')
        }, null, 544), [[_vModelText, form.targetOutputAmount]]), amountWarning.value ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(amountWarning.value), 1)) : _createCommentVNode("", true)]), _createElementVNode("label", _hoisted_23, [_cache[35] || (_cache[35] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("本月利润率（%） "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.targetProfitRatePercent = $event),
          type: "number",
          min: "0",
          step: "0.01",
          class: "form-input mt-1 w-full bg-white",
          placeholder: "请输入利润率"
        }, null, 512), [[_vModelText, form.targetProfitRatePercent]])]), _createElementVNode("label", _hoisted_24, [_cache[36] || (_cache[36] = _createElementVNode("span", {
          class: "form-label"
        }, "名单区域", -1)), _createVNode(_component_el_select, {
          "model-value": form.regionBucketId ?? '',
          class: "form-select mt-1 w-full bg-white",
          onChange: selectRegion
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "按注册地自动归类",
            value: ""
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.regions, region => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: region.id,
              label: region.regionName || '未命名区域',
              value: region.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["model-value"])]), _createElementVNode("div", _hoisted_25, [_createVNode(InvoiceProductQuotaEditor, {
          modelValue: form.outputProductQuotas,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => form.outputProductQuotas = $event),
          title: "销项品名组结构",
          "target-amount": normalizedTargetAmount.value,
          class: "rounded-lg border border-slate-200 bg-white p-3"
        }, null, 8, ["modelValue", "target-amount"])]), _createElementVNode("div", _hoisted_26, [_createVNode(InvoiceProductQuotaEditor, {
          modelValue: form.inputProductQuotas,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => form.inputProductQuotas = $event),
          title: "进项品名组结构",
          "target-amount": normalizedTargetAmount.value,
          class: "rounded-lg border border-slate-200 bg-white p-3"
        }, null, 8, ["modelValue", "target-amount"])]), _createElementVNode("div", _hoisted_27, [_createVNode(InvoiceCustomerInvoiceRulePanel, {
          customer: invoiceRuleCustomer.value,
          "downstream-allocations": draftDownstreamAllocations.value,
          "downstream-tag-preferences": draftDownstreamTagPreferences.value,
          disabled: isSubmitting.value,
          onConfigureDownstream: openDraftDownstreamAllocation,
          onConfigureTagPreference: openDraftDownstreamTagPreference
        }, null, 8, ["customer", "downstream-allocations", "downstream-tag-preferences", "disabled"])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("footer", _hoisted_28, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          disabled: isSubmitting.value,
          onClick: close
        }, "取消", 8, _hoisted_29), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-primary",
          disabled: isSubmitting.value,
          onClick: submit
        }, [_createTextVNode(_toDisplayString(isSubmitting.value ? '保存中...' : '保存'), 1)], 8, _hoisted_30)), [[_directive_permission, isEditMode.value ? 'enterprise-invoice:customer:update' : 'enterprise-invoice:customer:create']])])]),
        _: 1
      }, 8, ["visible"]), _createVNode(InvoiceDownstreamAllocationDialog, {
        modelValue: downstreamAllocationDialog.visible,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => downstreamAllocationDialog.visible = $event),
        customer: invoiceRuleCustomer.value,
        customers: __props.customers,
        allocations: combinedDraftDownstreamAllocations.value,
        submitting: isSubmitting.value,
        onSubmit: saveDraftDownstreamAllocations
      }, null, 8, ["modelValue", "customer", "customers", "allocations", "submitting"]), _createVNode(InvoiceDownstreamTagPreferenceDialog, {
        modelValue: downstreamTagPreferenceDialog.visible,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => downstreamTagPreferenceDialog.visible = $event),
        customer: invoiceRuleCustomer.value,
        tags: __props.availableTags,
        preferences: draftDownstreamTagPreferences.value,
        submitting: isSubmitting.value,
        onSubmit: saveDraftDownstreamTagPreferences
      }, null, 8, ["modelValue", "customer", "tags", "preferences", "submitting"])]);
    };
  }
};